(function () {
	'use strict';
	angular.module('app.setup')
    .service('flexFieldConfigRendererService', flexFieldConfigRendererService);
	flexFieldConfigRendererService.$inject = ['$rootScope', 'tableRenderService', 'flexFieldConfigService'];
  
	function flexFieldConfigRendererService($rootScope, tableRenderService, flexFieldConfigService) {
		var service = {
			textEditRenderer: textEditRenderer,
			filterTypeRenderer: filterTypeRenderer,
			textRenderer: textRenderer
		};

		var fieldTypeMap = flexFieldConfigService.fieldTypeMap;

		return service;

		function textEditRenderer(row, col, rowIndex, params) {
			var value = col.id == 'description' ? row[col.id] || row.columnName : row[col.id] || '';
			var grayClass = row.displayName == null || row.displayName == '' ? ' grayWhiteCell' : '';
			if (col.id == 'displayName' && (row.description == null || row.description == '')) {
				return '<div class="cell-div"></div>';
			}
			
			if (col.id == 'description' && !$rootScope.authz.isLeanDNACustomerAdmin()) {
				return '<div class="cell-div' + grayClass + '" title="' + value + '">' + value + '</div>';
			}
			
			var statusIcon = '';
			if (col.id == 'displayName') {
				statusIcon = '<div title="Field is active"><i class="fa inline-check fa-check-circle"></i></div>';
				if (row.displayName == null || row.displayName == '') {
					statusIcon = '<div><i class="fa inline-exclam fa-exclamation-circle" title="Add a display name to activate field"></i></div>';
				}
			}

			var editClickFunction = 'ng-click = "vm.startEdit(' + rowIndex + ',\'' + col.id + '\', \'' + col.display + '\', \'text\', 80, \'' + params.controllerName + '\',' + false + ')"';
			var nameElement = '<div class="name-field" title="' + value + '" ' + editClickFunction + '>' + value + '</div>';
			var actionElement = '<div class="editIcon" title="Edit" ' + editClickFunction + '><i class="fa fa-pencil"></i></div>';
			var deleteElement = '';
			var deleteClickFunction = 'ng-click="vm.deactivateFlexField(' + row.id + ',\'' + row.columnName + '\',\'' + col.id + '\',' + row.lastModified + ')"';
			if (row[col.id] != null && row[col.id] != '') {
				deleteElement = '<div class="editIcon" title="Remove & deactivate field">' +
          '<i class="fa fa-times" ' + deleteClickFunction + '></i>' +
          '</div>';
			}
			return '<div class="cell-div inline-edit-cell with-delete' + grayClass + '">' +
        '<div class="edit-name-text">' +
        statusIcon +
        nameElement +
        actionElement +
        deleteElement +
        '</div>' +
        '</div>';
		}

		function filterTypeRenderer(row, col, rowIndex, params) {
			var grayClass = row.displayName == null || row.displayName == '' ? ' grayWhiteCell' : '';
			if (row.displayName == null || row.displayName == '') {
				return '<div class="cell-div"></div>';
			}

			if (row.storageType !== 'string') {
				return '<div class="cell-div">' + row.filterTypeDisplay +'</div>';
			}
			params.grayClass = grayClass;
			return tableRenderService.inlineEditList(row, col, rowIndex, params);
		}

		function textRenderer(row, col, rowIndex, params) {
			var grayClass = row.displayName == null || row.displayName == '' ? ' grayWhiteCell' : '';

			var value = row[col.id];
			var tooltip = value;
			if (col.id == 'parent') {
				tooltip = fieldTypeMap[value].tooltip;
				value = fieldTypeMap[value].display;
			}

			if (col.id == 'sampleValue' && value == null) {
				tooltip = 'To disable this field in reports and filters, remove its display name.';
				value = 'No data loaded';
			}
			return '<div class="cell-div' + grayClass + '" title="' + tooltip + '">' + value + '</div>';
		}
	}
})();
